import { render, staticRenderFns } from "./AgentList.component.vue?vue&type=template&id=23dcd536&"
import script from "./AgentList.component.vue?vue&type=script&lang=ts&"
export * from "./AgentList.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports